import studentDailyActivity from '@/api/student-daily-activity'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  student_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STUDENT_ID(state, data) {
    state.student_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        student_id: context.state.student_id,
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return studentDailyActivity.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return studentDailyActivity.store(data)
  },

  update(context, data) {
    return studentDailyActivity.update(data)
  },
  destroy(context, id) {
    return studentDailyActivity.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await studentDailyActivity.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getClass(context, attributes = {}) {
    return studentDailyActivity.classRoom({ attributes })
  },
  getFindData(context, attributes = {}) {
    let params = Object.assign({
      class_id: attributes.class_id,
      student_id: attributes.student_id,
      activity_date: attributes.activity_date
    })
    return studentDailyActivity.findData({ params })
  },
  async getStudent(context, attributes = {}) {
    let params = Object.assign({
      class_id: attributes.class_id
    })
    return studentDailyActivity.student({ params })
  },
  getSetting(context) {
    return studentDailyActivity.getSetting()
  },
  manualRelease(context) {
    return studentDailyActivity.manualRelease()
  }
}
